import { h } from 'preact';
export const FastForward = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polygon", { points: "13 19 22 12 13 5 13 19" }),
        h("polygon", { points: "2 19 11 12 2 5 2 19" })));
};
//# sourceMappingURL=fast-forward.js.map